<template>
  <div class="container">
  </div>
</template>

<script>
export default {
  name: 'RedcHome',
  data() {

  },
  methods: {

  },
}
</script>

<style scoped></style>
